import React, { ReactNode } from "react";
import { Col, Collapse, CollapseProps, Row } from "antd";
import { ArrowDownIcon, ArrowUpIcon } from "@/icons/primary";
import { BemHelper } from "../../utils/BemHelper";
import classNames from "classnames";

const { Panel } = Collapse;

type Props = {
  title: ReactNode;
  opened?: boolean;
  children: React.ReactNode;
  bottomActions?: ReactNode;
  isInvalid?: boolean;
  extra?: React.ReactNode;
};

const bem = new BemHelper("collapsible-panel");

export const CollapsiblePanel: React.FC<Props & CollapseProps> = ({
  title,
  children,
  opened = false,
  bottomActions,
  isInvalid,
  extra,
  ...props
}) => {
  return (
    <Collapse
      defaultActiveKey={opened ? ["1"] : ["2"]}
      expandIconPosition='end'
      className={classNames(bem.block(), isInvalid && bem.modifier("is-invalid"))}
      expandIcon={({ isActive }) => (!isActive ? <ArrowDownIcon /> : <ArrowUpIcon />)}
      {...props}
    >
      <Panel
        header={
          <>
            <Row align='middle'>{title}</Row>
            {/* {isInvalid && (
              <span className={classNames(bem.element("header-additional-text"))}>
                required field
              </span>
            )} */}
          </>
        }
        key='1'
        forceRender
        extra={extra}
      >
        {children}
        {bottomActions && (
          <Row justify='end'>
            <Col>{bottomActions}</Col>
          </Row>
        )}
      </Panel>
    </Collapse>
  );
};
